import { render, staticRenderFns } from "./CompanyAlertsForm.vue?vue&type=template&id=c7c086c0"
import script from "./CompanyAlertsForm.vue?vue&type=script&lang=js"
export * from "./CompanyAlertsForm.vue?vue&type=script&lang=js"
import style0 from "./CompanyAlertsForm.vue?vue&type=style&index=0&id=c7c086c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports